export default "__VITE_ASSET__DryuUxlU__"